import React, { useRef } from "react";
import { BTN, INPUT } from "../crm/crmUtil";
import MergeFieldPicker from "./MergeFieldPicker";

// Editor for one template version: key/name/body/change note. Saving always creates a new version.
export default function TemplateEditorForm({ form, setForm, isNew, fields, labels, onSave, busy }) {
  const ta = useRef(null);
  const insert = (f) => {
    const el = ta.current, tok = `{{${f}}}`;
    const a = el ? el.selectionStart : form.body.length, b = el ? el.selectionEnd : form.body.length;
    setForm({ ...form, body: form.body.slice(0, a) + tok + form.body.slice(b) });
    requestAnimationFrame(() => { if (el) { el.focus(); el.setSelectionRange(a + tok.length, a + tok.length); } });
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSave(); }} className="space-y-3 min-w-0" data-testid="tpl-form">
      <div className="grid gap-2 sm:grid-cols-2">
        <label htmlFor="tpl-key" className="text-sm">Key (lowercase, a–z 0–9 _)
          <input id="tpl-key" value={form.key} onChange={set("key")} disabled={!isNew} pattern="[a-z0-9_]{3,40}" className={INPUT} data-testid="tpl-key" />
        </label>
        <label htmlFor="tpl-name" className="text-sm">Name<input id="tpl-name" value={form.name} onChange={set("name")} className={INPUT} data-testid="tpl-name" /></label>
      </div>
      <MergeFieldPicker fields={fields} labels={labels} onInsert={insert} />
      <label htmlFor="tpl-body" className="text-sm block">Contract text
        <textarea id="tpl-body" ref={ta} value={form.body} onChange={set("body")} rows={14}
          className="block mt-1 w-full rounded border border-erf-borderCream p-3 text-sm font-mono bg-white" data-testid="tpl-body" />
      </label>
      <label htmlFor="tpl-note" className="text-sm block">What changed (optional)<input id="tpl-note" value={form.note} onChange={set("note")} maxLength={300} className={INPUT} data-testid="tpl-note" /></label>
      <button type="submit" disabled={busy || form.body.trim().length < 20 || form.name.trim().length < 2 || !/^[a-z0-9_]{3,40}$/.test(form.key)}
        className={`${BTN} bg-erf-dark text-white w-full sm:w-auto`} data-testid="tpl-save">{busy ? "Saving…" : isNew ? "Save as v1" : "Save as new version"}</button>
    </form>
  );
}
